<template>
	<div class="ms-dropdown-content" :class="cssCustomDropdownContent">
		<div
			v-if="!$slots.content && !$slots.icon && !$scopedSlots.icon"
			class="w-full h-full"
		>
			<div class="flex items-center" v-if="type == 'primary'">
				<div @click="clickText" class="btn-text pr-4">{{ title }}</div>
				<div
					v-on="listenersIcon"
					ref="icon"
					class="ms-icon--dropdown"
					v-if="isShowIconDropdown"
				>
					<div v-if="textBeforeIcon" class="mr-1">{{ textBeforeIcon }}</div>
					<div
						class="padding-icon-dropdown"
						:class="[
							paddingIconStyle ? paddingIconStyle : '',
							showDropdownMenu ? 'active' : '',
						]"
					>
						<div
							:class="[
								'mi',
								'mi-24',
								isV2Icon ? 'mi-new-v2' : '',
								iconDropdown ? iconDropdown : 'mi-arrow-dropdown',
								'icon-show--dropdown',
							]"
						></div>
					</div>
				</div>
			</div>
			<div class="flex align-center" v-else-if="type == 'third'">
				<div @click="clickText" class="btn-text pr-4">{{ title }}</div>
			</div>
			<div class="flex items-center w-full h-full" v-else>
				<button
					class="ms-button-dropdown"
					:class="[btnType, { 'active-animation': animation && !disabled }]"
					@click="clickText"
					:disabled="disabled"
					v-on="listeners"
				>
					<div class="flex-1">{{ title }}</div>
					<div
						class="icon-input"
						v-tooltip="{
							content: errorProvider.message,
							show: focused,
							classes: `error`,
						}"
						v-if="errorProvider.isValid"
					>
						<div class="mi mi-24 mi-red-tick"></div>
					</div>
				</button>
				<button
					class="ms-icon--dropdown"
					:class="[btnType, { 'active-animation': animation && !disabled }]"
					v-on="listenersIcon"
					:disabled="disabled"
					ref="icon"
				>
					<div class="ms-icon-btn-dropdown">
						<div
							:class="[
								'mi',
								'mi-24',
								btnType != 'secondary'
									? 'mi-navbar-notification'
									: 'mi-arrow-dropdown',
								'icon-show--dropdown',
							]"
						></div>
					</div>
				</button>
			</div>
		</div>
		<div class="flex" v-else>
			<div v-if="$slots.header">
				<slot name="header"></slot>
			</div>
			<div @click="clickText" class="pr-4" v-if="$slots.content">
				<slot name="content"></slot>
			</div>
			<div v-on="listenersIcon" ref="icon" class="icon-show--dropdown w-full">
				<slot name="icon" :active="showDropdownMenu"></slot>
			</div>
		</div>
		<div
			class="layer-outsize"
			ref="layer"
			v-if="showDropdownMenu && eventActive != 'mouseover' && !level"
		></div>
		<keep-alive>
			<transition name="fade">
				<div
					class="ms-dropdown ms-dropdown-menu"
					:class="[
						customCssMenu,
						{ 'm-0': eventActive == 'mouseover' },
						menuDropdownNoBorderRadius ? 'ms-dropdown-menu-no-radius' : '',
					]"
					ref="dropdownMenu"
					:level="level"
					v-if="keepAlive || (showDropdownMenu && !keepAlive)"
					v-show="showDropdownMenu"
					key="dropdownmenu"
					:style="styleDropdown"
				>
					<div
						class="arrow-square--dropdown"
						ref="square"
						v-if="(arrow && $slots.default) || isShowArrow"
					></div>

					<slot :closeDropdown="closeDropdownMenu"></slot>
				</div>
			</transition>
		</keep-alive>
	</div>
</template>
<script>
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
import msBaseComponent from '@/components/msbase/msBaseComponent.vue';

export default {
	extends: msBaseComponent,
	name: 'msDropdown',
	props: {
		//Title hiện thị
		title: {
			default: null,
			type: String,
		},
		//Độ rộng của dropdown menu
		width: {
			default: null,
			type: [Number, String],
		},
		/**
		 * Loại drop down primary/button
		 */
		type: {
			default: 'primary',
			type: String,
		},
		//Dropdown loại hiện thị button
		btnType: {
			default: 'primary',
			type: String,
		},
		cssCustomDropdownContent: '',
		//Cấu hình độ dài tối đa cho dropdown
		height: {
			default: null,
			type: [Number, String],
		},
		minHeight: {
			default: null,
			type: [Number, String],
		},
		//Cấu hình scroll cho dropdown
		overflow: {
			default: 'auto',
			type: String,
		},
		//Thuộc tính disabled không cho thức hiện sự kiện mở dropdown
		disabled: {
			default: false,
			type: Boolean,
		},
		animation: {
			default: true,
			type: Boolean,
		},
		placement: {
			default: null,
			type: String,
		},
		eventActive: {
			default: 'click',
			type: String,
		},
		customCssMenu: {
			default: null,
			type: String,
		},
		customPosition: {
			default: null,
			type: Object,
		},
		keepAlive: {
			default: false,
			type: Boolean,
		},
		arrow: {
			default: false,
			type: Boolean,
		},
		iconDropdown: {
			default: null,
			type: String,
		},
		/**
		 * Có hiển thị icon dropdown hay không
		 */
		isShowIconDropdown: {
			default: true,
			type: Boolean,
		},
		/**
		 * Style vùng đệm của icon show drown
		 */
		paddingIconStyle: {
			default: null,
			type: String,
		},
		level: {
			default: 0,
			type: Number,
		},
		textBeforeIcon: {
			default: null,
			type: String,
		},
		/**
		 * Auto width dropdown theo text(item)
		 */
		autoWidthDropdown: {
			default: false,
			type: Boolean,
		},
		/**
		 * Có đóng dropdown khi scroll trên grid hay không
		 */
		closeDropDownWithScroll: {
			default: true,
			type: Boolean,
		},
		/**
		 * Trường hợp dropdown nằm trong các màn hình danh sách
		 */
		classBodyTable: {
			default: null,
			type: String,
		},
		isShowDropdownMenu: {
			default: false,
			type: Boolean,
		},
		formTranslateAva: {
			default: false,
			type: Boolean,
		},
		/**
		 * Prop dùng đề custom vị trí của hình tam giác ở dropdown
		 */
		customPositionSquare: {
			default: () => {},
			type: Object,
		},
		styleDropCustom: {
			default: null,
			type: Object,
		},
		/**
		 * Biến muốn hiển thị tam giác mà không quan tâm có điều kiện $slot.default hay không
		 */
		isShowArrow: {
			default: false,
			type: Boolean,
		},
		disabledClickOff: {
			default: false,
			type: Boolean,
		},
		menuDropdownNoBorderRadius: {
			default: false,
			type: Boolean,
		},
		isCalculatorPostionTop: {
			default: true,
			type: Boolean,
		},
		/**
		 * Khoảng cách dịch dropdown menu (kèm tam giác) xuống dưới so với đáy icon (px)
		 * Mặc định 0 — giữ nguyên hành vi cũ
		 * Created by PDDANG on 12/10/2026
		 */
		menuOffsetTop: {
			default: 0,
			type: Number,
		},
	},
	data() {
		return {
			//Trạng thái show dropdown hay không
			showDropdownMenu: false,
			focused: false,
		};
	},
	computed: {
		isV2Icon() {
			return (
				this.iconDropdown &&
				(this.iconDropdown.includes('-v2-') ||
					this.iconDropdown.includes('-connected'))
			);
		},
		listeners() {
			const me = this;
			return {
				focus: () => {
					me.focused = true;
				},
				blur: () => {
					me.focused = false;
				},
			};
		},
		listenersIcon() {
			const me = this;
			if (!me.disabled) {
				let event = {};
				if (me.eventActive == 'mouseover') {
					event[me.eventActive] = () => {
						me.clickIcon(true);
					};
				} else {
					event[me.eventActive] = () => {
						me.clickIcon();
					};
				}
				return {
					...event,
				};
			}
		},
		/**
		 * set độ dộng cho dropdown menu
		 */
		styleDropdown() {
			const me = this;
			let styleDropD = {
				minWidth: `${this.width}px`,
				width: me.autoWidthDropdown ? `auto` : `${this.width}px`,
				maxHeight: `${this.height}px`,
				overflow: this.overflow,
				height: this.minHeight ? `${this.minHeight}px` : 'auto',
			};

			if (me.styleDropCustom && Object.keys(me.styleDropCustom).length > 0) {
				return { ...styleDropD, ...me.styleDropCustom };
			}
			return styleDropD;
		},
	},
	created() {
		const me = this;
		EventBusGlobal.$on(GlobalEventName.scrollEvent, me.scrollEvent);
		EventBusGlobal.$on(GlobalEventName.closeAllDropdown, me.closeDropdownMenu);
		window.addEventListener('resize', me.onWindowResize);
		if (me.isShowDropdownMenu) {
			me.clickIcon(true);
		}
	},
	methods: {
		scrollEvent(e) {
			// Form lọc (keepAlive=true) không đóng khi grid scroll — tránh đóng khi zoom/resize trình duyệt làm grid scroll
			if (this.showDropdownMenu && this.closeDropDownWithScroll && !this.keepAlive) {
				this.closeDropdownMenu();
			}
		},
		//Xử lý sự kiện resize cửa sổ trình duyệt (bao gồm cả zoom)
		//Khi keepAlive=true (thường là form lọc), chỉ cập nhật lại vị trí thay vì đóng
		//Created by DQDUY(06.08.2026)
		onWindowResize() {
			const me = this;
			if (me.showDropdownMenu) {
				if (me.keepAlive) {
					me.updatePositionDropdownMenu();
				} else {
					me.closeDropdownMenu();
				}
			}
		},
		//Sự kiện click vào tiêu đề của dropdown
		//Created by LTDAT(13.06.2020)
		clickText(event) {
			const me = this;
			if (!me.disabled) {
				me.$emit('click', event);
			}
		},
		//Sự kiện khi ấn vào icon để mở dropdownmenu
		//Created by LTDAT(13.06.2020)
		clickIcon(isShow) {
			const me = this;
			if (!me.disabled) {
				me.showDropdownMenu = isShow || !me.showDropdownMenu;
				me.$nextTick(() => {
					let dropdownMenu = me.$refs.dropdownMenu;
					if (me.showDropdownMenu && dropdownMenu) {
						setTimeout(() => {
							me.updatePositionDropdownMenu();
							me.addEventCloseDropdown();
							me.scrollChildOfDropMenuToTop();
						}, 20);
						document.body.appendChild(me.$refs.dropdownMenu);
						me.$emit('afterAppendChild', me.showDropdownMenu);
					}
				});
				me.$emit('clickIcon', me.showDropdownMenu);
			}
		},

		scrollChildOfDropMenuToTop() {
			const me = this;
			const dropdownMenu = me.$refs.dropdownMenu;
			if (!dropdownMenu) return;

			// Duyệt qua tất cả phần tử con của dropdownMenu
			const children = dropdownMenu.querySelectorAll('*');
			if (!children || children.length <= 0) return;

			for (let child of children) {
				const style = window.getComputedStyle(child);
				const overflowY = style.overflowY;
				// Kiểm tra nếu phần tử có scroll dọc
				if (
					(overflowY === 'scroll' || overflowY === 'auto') &&
					child.scrollHeight > child.clientHeight
				) {
					child.scrollTop = 0;
				}
			}
		},

		addEventCloseDropdown() {
			const me = this;
			switch (me.eventActive) {
				case 'click':
					{
						document.addEventListener('mousedown', me.clickOff);
					}
					break;
				case 'mouseover':
					{
						document.addEventListener('mousemove', me.clickOff);
					}
					break;
			}
		},
		removeEventCloseDropdown() {
			const me = this;
			switch (me.eventActive) {
				case 'click':
					{
						document.removeEventListener('mousedown', me.clickOff);
					}
					break;
				case 'mouseover':
					{
						document.removeEventListener('mouseleave', me.clickOff);
					}
					break;
			}
		},
		/**
		 * Đóng dropdown menu
		 */
		closeDropdownMenu() {
			const me = this;
			me.closeDropdown();
			me.removeEventCloseDropdown();
			// document.removeEventListener('mousedown', this.clickOff);
		},
		//Cập nhật lại tọa độ của dropdown menu
		//Created by LTDAT(13.06.2020)
		updatePositionDropdownMenu() {
			const me = this;
			if (me.$refs.dropdownMenu) {
				let rectDropdownMenu = me.$refs.dropdownMenu.getBoundingClientRect(),
					rectIcon = me.$el.getBoundingClientRect(),
					windowWidth =
						window.innerWidth ||
						document.documentElement.clientWidth ||
						document.body.clientWidth,
					windowHeight =
						window.innerHeight ||
						document.documentElement.clientHeight ||
						document.body.clientHeight;
				if (
					rectIcon.left + rectDropdownMenu.width > windowWidth ||
					me.formTranslateAva
				) {
					me.$refs.dropdownMenu.style.left =
						rectIcon.right - rectDropdownMenu.width <= 0
							? '2px'
							: rectIcon.right - rectDropdownMenu.width + 'px';
					// me.$refs.square.style.right = '5px';
				} else {
					if (me.placement == 'right') {
						me.$refs.dropdownMenu.style.left =
							rectIcon.right - rectDropdownMenu.width <= 0
								? '2px'
								: rectIcon.right - rectDropdownMenu.width + 'px';
					} else if (me.placement == 'center') {
						me.$refs.dropdownMenu.style.left =
							rectIcon.left - rectDropdownMenu.width / 2 + 'px';
					} else {
						me.$refs.dropdownMenu.style.left = rectIcon.left + 'px';
					}
				}

				//triange
				if (me.$refs.square) {
					me.$refs.square.style.left =
						rectIcon.left +
						rectIcon.width / 2 +
						me.caculatorCustomPositionSquare('left') -
						10 +
						'px';
					me.$refs.square.style.top =
						rectIcon.bottom +
						me.caculatorCustomPositionSquare('top') -
						8 +
						me.menuOffsetTop +
						'px';
					if (rectIcon.bottom + rectDropdownMenu.height > windowHeight) {
						me.$refs.square.style.top =
							rectIcon.top - 8 - me.menuOffsetTop + 'px';
						me.$refs.square.style.transform = 'rotate(180deg)';
					}
				}

				if (me.classBodyTable) {
					let bodyTable = document.querySelector(`.${me.classBodyTable}`);
					if (bodyTable) {
						let offsetBody = bodyTable.getBoundingClientRect();
						if (rectIcon.bottom + rectDropdownMenu.height > offsetBody.bottom) {
							let newTop = rectIcon.top - rectDropdownMenu.height;
							if (newTop <= offsetBody.top) {
								me.$refs.dropdownMenu.style.top = offsetBody.top + 'px';
								if (rectDropdownMenu.height > offsetBody.height) {
									//PDDang check lại chỗ này sao gắn data trong propsS
									// me.height = offsetBody.height;
								}
							} else {
								me.$refs.dropdownMenu.style.top = newTop + 'px';
							}
						} else {
							me.$refs.dropdownMenu.style.top =
								rectIcon.bottom + me.menuOffsetTop + 'px';
						}
					}
				} else if (rectIcon.bottom + rectDropdownMenu.height > windowHeight) {
					me.$refs.dropdownMenu.style.top =
						rectIcon.top - me.menuOffsetTop - rectDropdownMenu.height + 'px';
				} else {
					me.$refs.dropdownMenu.style.top =
						rectIcon.bottom + me.menuOffsetTop + 'px';
				}

				if (me.formTranslateAva) {
					me.$refs.dropdownMenu.style.top = rectIcon.bottom + 8 + 'px';
				}

				if (me.customPosition) {
					if (me.customPosition.hasOwnProperty('top')) {
						me.$refs.dropdownMenu.style.top = me.customPosition.top;
						if (
							parseFloat(me.customPosition.top) + rectDropdownMenu.height >
							windowHeight
						) {
							me.$refs.dropdownMenu.style.top =
								parseFloat(me.customPosition.top) -
								rectDropdownMenu.height +
								'px';
						}
					}
					if (me.customPosition.hasOwnProperty('bottom')) {
						me.$refs.dropdownMenu.style.bottom = me.customPosition.bottom;
						if (me.isCalculatorPostionTop) {
							me.$refs.dropdownMenu.style.top =
								parseInt(me.$refs.dropdownMenu.style.top) - 25 + 'px';
						}
					}
					if (me.customPosition.hasOwnProperty('left')) {
						if (
							parseFloat(me.customPosition.left) + rectDropdownMenu.width >
							windowWidth
						) {
							me.$refs.dropdownMenu.style.left = `${
								parseFloat(me.customPosition.left) - rectDropdownMenu.width
							}px`;
						} else {
							me.$refs.dropdownMenu.style.left = me.customPosition.left;
						}
					}
					if (me.customPosition.hasOwnProperty('right')) {
						me.$refs.dropdownMenu.style.right = me.customPosition.right;
					}
				}
			}
		},

		caculatorCustomPositionSquare(value) {
			const me = this;
			if (!value || !me.customPositionSquare) return 0;

			if (value == 'left' && me.customPositionSquare.left) {
				return me.customPositionSquare.left || 0;
			}

			if (value == 'top' && me.customPositionSquare.top) {
				return me.customPositionSquare.top || 0;
			}
			return 0;
		},
		//Sự kiện đóng dropdown menu khi click ra ngoài dropdownmenu
		clickOff(event) {
			const me = this;
			if (me.disabledClickOff) {
				return;
			}

			const targetDropdown =
				event.target.closest('.ms-dropdown') ||
				event.target.closest('.ms-dropdown-menu');
			var level = -1;
			if (targetDropdown && targetDropdown.attributes.level)
				level = targetDropdown.attributes.level.value;

			const isInside = level >= me.level;
			if (
				!isInside &&
				!event.target.closest('.ms-icon--dropdown') &&
				!event.target.closest('.icon-show--dropdown') &&
				!event.target.closest('.calendar') &&
				!event.target.closest('.ms-mesage-box') &&
				!event.target.closest('.combo-dropdown-panel') &&
				!event.target.closest('#loading-bg') &&
				!event.target.closest('#loading-filler')
			) {
				me.closeDropdown(true);
				document.removeEventListener('mousedown', me.clickOff);
			}

			const targetIcon =
				event.target.closest('.icon-show--dropdown') ||
				event.target.closest('.ms-icon--dropdown');

			if (
				targetIcon &&
				!isInside &&
				targetIcon != me.$refs.icon &&
				me.$refs.icon &&
				!me.$refs.icon.contains(targetIcon)
			) {
				me.closeDropdown();
				me.removeEventCloseDropdown();
			}
		},
		closeDropdown(outSize = false) {
			const me = this;
			me.showDropdownMenu = false;
			if (me.classBodyTable) me.height = null;
			me.$emit('close', outSize);
		},
	},
	beforeDestroy() {
		const me = this;
		me.closeDropdown();
		if (me.$refs.dropdownMenu) {
			me.$refs.dropdownMenu.remove();
		}

		window.removeEventListener('resize', me.onWindowResize);
		me.removeEventCloseDropdown();
		EventBusGlobal.$off(GlobalEventName.scrollEvent, me.scrollEvent);
		EventBusGlobal.$off(GlobalEventName.closeAllDropdown, me.closeDropdownMenu);
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msDropdown.scss';
}

@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msDropdown.scss';
}

.dropdown-ava-explain {
	background: linear-gradient(180deg, #c7daff 0%, #4785ff 100%) !important;
	border-radius: 6px 0 6px 6px !important;
}
</style>
